import { TableColumn } from "../../models/tables/TableColumn";
import { COLUMN_TYPES } from "../COLUMN_TYPES";

export const PayrollColumns: TableColumn[] = [
    {
        name: "type", 
        displayName: "Type", 
        dataType: COLUMN_TYPES.string
    },
    {
        name: "dateFrom", 
        displayName: "Date From", 
        dataType: COLUMN_TYPES.date
    },
    {
        name: "dateTo", 
        displayName: "Date To", 
        dataType: COLUMN_TYPES.date
    }
]


// WEBPACK FOOTER //
// ./src/app/contants/columns/columns.payroll.list.ts